// Stream's Activity Feeds v3 only tracks read/seen state for feed groups of type
// "notification" (see docs/stream-business-rules.md), which this app's Stream setup
// does not have configured yet. Until that infra lands, "unread" for the feed is
// derived locally per device/browser from a last-read watermark - hence "local
// notifications". Stream Chat, by contrast, already tracks read state natively per
// channel/member, so chat notifications should not need this once they're implemented.
import {
    createLocalStorageItem,
    LocalStorageItem,
    parseDate,
    serializeDate,
} from './localStorageItem'

const STORAGE_KEY_PREFIX = 'valk-talk-notifications-last-read'

export const lastReadAtStorage = (source: string, userId: string): LocalStorageItem<Date | null> => createLocalStorageItem<Date | null>({
    key: `${STORAGE_KEY_PREFIX}:${source}:${userId}`,
    fallback: null,
    parse: parseDate,
    serialize: date => (date ? serializeDate(date) : ''),
})

export const getLastReadAt = (source: string, userId: string): Date | null => lastReadAtStorage(source, userId).get()

export const setLastReadAt = (source: string, userId: string, readAt: Date): void => {
    lastReadAtStorage(source, userId).set(readAt)
}
